export const MerchantListItemActionFooterUat = {
  selectMerchantButton:
    'merchantSelection.merchantListItem.selectMerchantButton'
}
